import { CarouselNext, CarouselPrevious, Chevron } from './CarouselControl.styles';

interface CarouselControlProps {
  type: 'previous' | 'next';
  id: string;
}

const CarouselControl = ({ type, id }: CarouselControlProps) => {
  const types = {
    next: {
      wrapper: CarouselNext,
      className: 'next',
      direction: 'right',
    },
    previous: {
      wrapper: CarouselPrevious,
      className: 'prev',
      direction: 'left',
    },
  };

  const curType = types[type];
  const Wrapper = curType.wrapper;

  return (
    <Wrapper className={`carousel-${curType.className}-${id}`}>
      <Chevron
        className={`carousel-${curType.className}-chevron-${id}`}
        name={`bxs-chevron-${curType.direction}` as IconName}
      />
    </Wrapper>
  );
};

export default CarouselControl;
